/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_TitleInputs */



/**
* | output |
* | --- |
* | "Menu" |
*
* @param {Context_Menu_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_title = /** @type {((inputs?: Context_Menu_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Menu")
	if (locale === "de") return /** @type {LocalizedString} */ ("Speisekarte")
	if (locale === "it") return /** @type {LocalizedString} */ ("Menu")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Меню")
	if (locale === "es") return /** @type {LocalizedString} */ ("Menú")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("菜单")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メニュー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मेनू")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Menu")
	return /** @type {LocalizedString} */ ("Menu")
});